import React, { useState } from 'react';
import recarxlogo from '../assets/images/logo512.png';
/* Original: import { Car, Menu, X, Sun, Moon, Phone, AlertTriangle, User, Settings } from 'lucide-react'; */
import { Menu, X, AlertTriangle, User } from 'lucide-react'; // Sun, Moon, 
/*import { useTheme } from '../hooks/useTheme.ts';*/
import { useAuth } from '../context/AuthContext.tsx'

interface HeaderProps {
  onEmergencyClick: () => void;
  onLoginClick: () => void;
  onRegisterClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onEmergencyClick, onLoginClick, onRegisterClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  /* const { isDark, toggleTheme } = useTheme(); */
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <header className="header-sticky">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img
              src={recarxlogo}
              alt="Recarx Plus Logo"
              className="h-14 w-14 object-contain"
              style={{ display: 'block' }}
            />
            <div>
              <h1 className="brand-title">RECARX PLUS</h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <a href="#servicios" className="nav-link">Servicios</a>
            <a href="#proveedores" className="nav-link">Proveedores</a>
            <a href="#testimonios" className="nav-link">Testimonios</a>
            <a href="#contacto" className="nav-link">Contacto</a>
          </nav>

          {/* Action Buttons */}
          <div className="flex items-center space-x-2">
            {/* 
            <button onClick={toggleTheme} className="btn-icon">
              {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>
            */}
            
            <button onClick={onEmergencyClick} className="hidden sm:flex btn-emergency">
              <AlertTriangle className="h-4 w-4" />
              <span>Emergencia</span>
            </button>

            {isAuthenticated ? (
              <>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Bienvenido {user?.username}
                </span>
                <button onClick={logout} className="btn-secondary">
                  Cerrar sesión
                </button>
              </>
            ) : (
              <>
                <button onClick={onLoginClick} className="hidden sm:flex btn-secondary">
                  <User className="h-4 w-4" />
                  <span>Ingresar</span>
                </button>
                <button onClick={onRegisterClick} className="hidden sm:block btn-primary">
                  Registrarse
                </button>
              </>
            )}

            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden btn-icon">
              {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 dark:border-gray-700">
            <div className="flex flex-col space-y-3">
              <button onClick={onEmergencyClick} className="btn-emergency-mobile">
                <AlertTriangle className="h-5 w-5" />
                <span>Emergencia 24/7</span>
              </button>

              <a href="#servicios" className="nav-link-mobile">Servicios</a>
              <a href="#proveedores" className="nav-link-mobile">Proveedores</a>
              <a href="#testimonios" className="nav-link-mobile">Testimonios</a>
              <a href="#contacto" className="nav-link-mobile">Contacto</a>

              <div className="border-t border-gray-200 dark:border-gray-700 pt-3 space-y-2">
                {isAuthenticated ? (
                  <>
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Bienvenido {user?.username}
                    </span>
                    <button onClick={logout} className="btn-secondary">
                      Cerrar sesión
                    </button>
                  </>
                ) : (
                  <>
                    <button onClick={onLoginClick} className="hidden sm:flex btn-secondary">
                      <User className="h-4 w-4" />
                      <span>Ingresar</span>
                    </button>
                    <button onClick={onRegisterClick} className="hidden sm:block btn-primary">
                      Registrarse
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};